import { ValidationSchemas, lookupConfig } from "./formConstants";
import CopyFieldsButton from "../components/CopyFieldsButton";

export const PURPOSE_OF_EXEMPT_WELL_FIELDS = [
  "fl_domestic",
  "fl_agricultural",
  "fl_geothermal_exempt",
  "fl_wildlife",
  "fl_irrigation",
  "fl_pws",
  "fl_community_ws",
  "fl_retail_pws",
  "fl_commercial",
  "fl_dewatering",
  "fl_industrial",
  "fl_injection",
  "fl_monitor",
  "fl_aquifer_test_obser",
  "fl_aquifer_test_pump",
  "fl_remediation",
  "fl_other_exempt",
];

const existingWellRegistrationFormConfig = [
  /* ───────────────────────────  A. WELL OWNER  ─────────────────────── */
  {
    title: "Well Owner Information",
    step: "Well Owner Info",
    fields: [
      {
        name: "name_first_owner",
        label: "First Name",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "name_last_owner",
        label: "Last Name",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "phone_primary_owner",
        label: "Primary Phone",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_line_1_owner",
        label: "Mailing Address",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_city_owner",
        label: "City",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_state_owner",
        label: "State",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_zip_owner",
        label: "Zip",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "email_owner",
        label: "Email",
        type: "text",
        infoTooltip: "For fastest response of confirmation",
        validation: ValidationSchemas.requiredEmail,
      },
    ],
  },

  /* ───────────────────  B. WELL USE  ─────────────────── */
  {
    title: "Well Use",
    subtitle: "Check One",
    step: "Well Use",
    fields: [
      {
        name: "exempt_purpose_types",
        type: "subHeader",
        label: "Exempt Purpose Types",
        content: (
          <>
            See{" "}
            <a
              href="https://haysgroundwater.com/regulatory/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hays Trinity Groundwater Conservation District Rules
            </a>{" "}
            for full definitions.
          </>
        ),
      },
      {
        name: "fl_domestic",
        label: "Residential / Domestic Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used solely for domestic use by a single private residential household and producing less than 25,000 gallons per day. The private use of groundwater by an individual or a household, not provided by a third party, for the daily needs of a household, including water for use inside the home; for irrigation of lawns, or of a family garden or orchard that produces fruits or vegetables for consumption within the residence and not for sale; for watering of domestic animals; for swimming pools associated with a single residence; for stock-watering ponds of less than ¼-acre extent with an average depth of less than 3-feet, that are lined with bentonite, geomembrane, or an equivalent sealing material as adjudged by the District. Domestic use does not include water used by, or to support, activities for which consideration is given or received or for which the product of the activity is sold. Domestic use does not include use by or for a third party, including a public water system.",
          falseLabel:
            "A well used solely for domestic use by a single private residential household and producing less than 25,000 gallons per day. The private use of groundwater by an individual or a household, not provided by a third party, for the daily needs of a household, including water for use inside the home; for irrigation of lawns, or of a family garden or orchard that produces fruits or vegetables for consumption within the residence and not for sale; for watering of domestic animals; for swimming pools associated with a single residence; for stock-watering ponds of less than ¼-acre extent with an average depth of less than 3-feet, that are lined with bentonite, geomembrane, or an equivalent sealing material as adjudged by the District. Domestic use does not include water used by, or to support, activities for which consideration is given or received or for which the product of the activity is sold. Domestic use does not include use by or for a third party, including a public water system.",
          nullLabel:
            "A well used solely for domestic use by a single private residential household and producing less than 25,000 gallons per day. The private use of groundwater by an individual or a household, not provided by a third party, for the daily needs of a household, including water for use inside the home; for irrigation of lawns, or of a family garden or orchard that produces fruits or vegetables for consumption within the residence and not for sale; for watering of domestic animals; for swimming pools associated with a single residence; for stock-watering ponds of less than ¼-acre extent with an average depth of less than 3-feet, that are lined with bentonite, geomembrane, or an equivalent sealing material as adjudged by the District. Domestic use does not include water used by, or to support, activities for which consideration is given or received or for which the product of the activity is sold. Domestic use does not include use by or for a third party, including a public water system.",
        },
      },
      {
        name: "fl_agricultural",
        label: "Agricultural and Livestock Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "The use of groundwater for: (A) Cultivating the soil to produce crops for human food, animal feed, or planting seed or for the production of fibers; (B) Practicing floriculture, viticulture, silviculture, and horticulture, including the cultivation of plants in containers or non-soil media, by a nursery grower; (C) Raising, feeding, or keeping animals for breeding purposes or for the production of food or fiber, leather, pelts, or other tangible products having a commercial value; (D) Planting cover crops, including cover crops cultivated for transplantation, or leaving land idle for the purpose of participating in any governmental program or normal crop or livestock rotation procedure; (E) Engaging in wildlife management as defined in Texas Tax Code Section 23.51(7); and, (F) Raising or keeping equine animals.",
          falseLabel:
            "The use of groundwater for: (A) Cultivating the soil to produce crops for human food, animal feed, or planting seed or for the production of fibers; (B) Practicing floriculture, viticulture, silviculture, and horticulture, including the cultivation of plants in containers or non-soil media, by a nursery grower; (C) Raising, feeding, or keeping animals for breeding purposes or for the production of food or fiber, leather, pelts, or other tangible products having a commercial value; (D) Planting cover crops, including cover crops cultivated for transplantation, or leaving land idle for the purpose of participating in any governmental program or normal crop or livestock rotation procedure; (E) Engaging in wildlife management as defined in Texas Tax Code Section 23.51(7); and, (F) Raising or keeping equine animals.",
          nullLabel:
            "The use of groundwater for: (A) Cultivating the soil to produce crops for human food, animal feed, or planting seed or for the production of fibers; (B) Practicing floriculture, viticulture, silviculture, and horticulture, including the cultivation of plants in containers or non-soil media, by a nursery grower; (C) Raising, feeding, or keeping animals for breeding purposes or for the production of food or fiber, leather, pelts, or other tangible products having a commercial value; (D) Planting cover crops, including cover crops cultivated for transplantation, or leaving land idle for the purpose of participating in any governmental program or normal crop or livestock rotation procedure; (E) Engaging in wildlife management as defined in Texas Tax Code Section 23.51(7); and, (F) Raising or keeping equine animals.",
        },
      },
      {
        name: "num_ag_registration",
        label: "Texas Agricultural or Timber Registration Number",
        type: "text",
        validation: ValidationSchemas.string,
        showIf: {
          fn: (values) => values.fl_agricultural,
          deps: ["fl_agricultural"],
          required: true,
        },
        refine: (data) => {
          if (data.fl_agricultural && !data.num_ag_registration) {
            return "Required if Agricultural Well is selected";
          }
          return undefined;
        },
      },
      {
        name: "fl_geothermal_exempt",
        label: "GeoExchange / Geothermal Exempt",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used solely for earth-coupled heat exchange purposes and not equipped to produce groundwater.",
          falseLabel:
            "A well used solely for earth-coupled heat exchange purposes and not equipped to produce groundwater.",
          nullLabel:
            "A well used solely for earth-coupled heat exchange purposes and not equipped to produce groundwater.",
        },
      },
      {
        name: "num_geothermal_exempt",
        label: "Geothermal Exempt Registration Number",
        type: "text",
        validation: ValidationSchemas.string,
        showIf: {
          fn: (values) => values.fl_geothermal_exempt,
          deps: ["fl_geothermal_exempt"],
          resetValue: "",
          required: true,
        },
        refine: (data) => {
          if (data.fl_geothermal_exempt && !data.num_geothermal_exempt) {
            return "Required if GeoExchange / Geothermal Exempt is selected";
          }
          return undefined;
        },
      },
      {
        name: "fl_wildlife",
        label: "Wildlife Management Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "a well drilled and operated solely for providing water for wildlife, if the well is drilled, completed, or equipped so that it is incapable of producing more than 25,000 gallons of groundwater a day and located on a tract of land equal to or greater than 10 acres.",
          falseLabel:
            "a well drilled and operated solely for providing water for wildlife, if the well is drilled, completed, or equipped so that it is incapable of producing more than 25,000 gallons of groundwater a day and located on a tract of land equal to or greater than 10 acres.",
          nullLabel:
            "a well drilled and operated solely for providing water for wildlife, if the well is drilled, completed, or equipped so that it is incapable of producing more than 25,000 gallons of groundwater a day and located on a tract of land equal to or greater than 10 acres.",
        },
      },
      {
        name: "num_of_wells_geothermal_exempt",
        label: "Number of Wells for GeoExchange / Geothermal Exempt",
        type: "number",
        validation: ValidationSchemas.positiveInt,
        showIf: {
          fn: (values) => values.fl_geothermal_exempt,
          deps: ["fl_geothermal_exempt"],
          resetValue: null,
          required: true,
        },
        refine: (data) => {
          if (
            data.fl_geothermal_exempt &&
            !data.num_of_wells_geothermal_exempt
          ) {
            return "Required if GeoExchange / Geothermal Exempt is selected";
          }
          return undefined;
        },
      },
      {
        name: "non_exempt_purpose_types",
        type: "subHeader",
        label: "Non-Exempt Purpose Types",
        content: (
          <>
            Requires Drilling Permit. Complete this Well Notification Form and
            then contact the District Office for a Drilling Permit Application.
            See{" "}
            <a
              href="https://haysgroundwater.com/regulatory/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hays Trinity Groundwater Conservation District Rules
            </a>{" "}
            for additional information.
          </>
        ),
      },
      {
        name: "fl_irrigation",
        label: "Irrigation Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used to supply water for application to plants or land in order to promote growth of plants, turf, or trees. Agriculture and Residential/Domestic purposes are exempt from obtaining an operating permit (see definitions above).",
          falseLabel:
            "A well used to supply water for application to plants or land in order to promote growth of plants, turf, or trees. Agriculture and Residential/Domestic purposes are exempt from obtaining an operating permit (see definitions above).",
          nullLabel:
            "A well used to supply water for application to plants or land in order to promote growth of plants, turf, or trees. Agriculture and Residential/Domestic purposes are exempt from obtaining an operating permit (see definitions above).",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_pws",
        label: "Public Water System",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A system as defined by 30 Texas Administrative Code Section 290.38 for providing water to the public for human consumption.",
          falseLabel:
            "A system as defined by 30 Texas Administrative Code Section 290.38 for providing water to the public for human consumption.",
          nullLabel:
            "A system as defined by 30 Texas Administrative Code Section 290.38 for providing water to the public for human consumption.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_community_ws",
        label: "Community Water System",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A system, other than a public water system, that supplies groundwater to long-term living units such as apartment complexes, town homes, or multiple dwellings on a shared well.",
          falseLabel:
            "A system, other than a public water system, that supplies groundwater to long-term living units such as apartment complexes, town homes, or multiple dwellings on a shared well.",
          nullLabel:
            "A system, other than a public water system, that supplies groundwater to long-term living units such as apartment complexes, town homes, or multiple dwellings on a shared well.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_retail_pws",
        label: "Retail Public Water Utility",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A person providing groundwater to the public for human consumption through pipes or other constructed conveyances. As defined by 30 Texas Administrative Code Section 291.3, it is any person, corporation, public utility, water supply corporation, municipality, political subdivision or agency operating, maintaining, or controlling within the District facilities for providing potable water service for compensation.",
          falseLabel:
            "A person providing groundwater to the public for human consumption through pipes or other constructed conveyances. As defined by 30 Texas Administrative Code Section 291.3, it is any person, corporation, public utility, water supply corporation, municipality, political subdivision or agency operating, maintaining, or controlling within the District facilities for providing potable water service for compensation.",
          nullLabel:
            "A person providing groundwater to the public for human consumption through pipes or other constructed conveyances. As defined by 30 Texas Administrative Code Section 291.3, it is any person, corporation, public utility, water supply corporation, municipality, political subdivision or agency operating, maintaining, or controlling within the District facilities for providing potable water service for compensation.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_commercial",
        label: "Commercial Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "The use of groundwater to supply water to properties or establishments that are in business to build, supply or sell products, or provide goods, services or repairs and that use water in those processes, or to supply water to the business establishment primarily for employee and customer conveniences (i.e. flushing of toilets, sanitary purposes, or limited landscape watering).",
          falseLabel:
            "The use of groundwater to supply water to properties or establishments that are in business to build, supply or sell products, or provide goods, services or repairs and that use water in those processes, or to supply water to the business establishment primarily for employee and customer conveniences (i.e. flushing of toilets, sanitary purposes, or limited landscape watering).",
          nullLabel:
            "The use of groundwater to supply water to properties or establishments that are in business to build, supply or sell products, or provide goods, services or repairs and that use water in those processes, or to supply water to the business establishment primarily for employee and customer conveniences (i.e. flushing of toilets, sanitary purposes, or limited landscape watering).",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_dewatering",
        label: "Dewatering Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used temporarily for lowering the water table for construction purposes.",
          falseLabel:
            "A well used temporarily for lowering the water table for construction purposes.",
          nullLabel:
            "A well used temporarily for lowering the water table for construction purposes.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_industrial",
        label: "Industrial Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "Use of groundwater primarily in the building, production, manufacturing, or alteration of a product or goods, or to wash, cleanse, cool, or heat such goods or products.",
          falseLabel:
            "Use of groundwater primarily in the building, production, manufacturing, or alteration of a product or goods, or to wash, cleanse, cool, or heat such goods or products.",
          nullLabel:
            "Use of groundwater primarily in the building, production, manufacturing, or alteration of a product or goods, or to wash, cleanse, cool, or heat such goods or products.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_injection",
        label: "Injection Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used to inject water or other material into a subsurface formation or into pipe or tubing placed in the formation for the purpose of storage or disposal of the fluid.",
          falseLabel:
            "A well used to inject water or other material into a subsurface formation or into pipe or tubing placed in the formation for the purpose of storage or disposal of the fluid.",
          nullLabel:
            "A well used to inject water or other material into a subsurface formation or into pipe or tubing placed in the formation for the purpose of storage or disposal of the fluid.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_monitor",
        label: "Monitor Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well generally used for collecting water-quality and/or water-level data on an ongoing basis.",
          falseLabel:
            "A well generally used for collecting water-quality and/or water-level data on an ongoing basis.",
          nullLabel:
            "A well generally used for collecting water-quality and/or water-level data on an ongoing basis.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_aquifer_test_obser",
        label: "Aquifer Test Observation Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well for observing water level changes during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
          falseLabel:
            "A well for observing water level changes during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
          nullLabel:
            "A well for observing water level changes during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_aquifer_test_pump",
        label: "Aquifer Test Pumping Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "The pumping well used during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
          falseLabel:
            "The pumping well used during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
          nullLabel:
            "The pumping well used during an aquifer test, drilled prior to drilling a well in connection with an operating permit to evaluate groundwater quality or quantity, including a test well required under Section 11.6.4.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "fl_remediation",
        label: "Remediation Well",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel:
            "A well used to pump or vent contaminated air, water, or fluids from the ground.",
          falseLabel:
            "A well used to pump or vent contaminated air, water, or fluids from the ground.",
          nullLabel:
            "A well used to pump or vent contaminated air, water, or fluids from the ground.",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "other_purpose_type",
        type: "subHeader",
        label: "Other Purpose Type",
      },
      {
        name: "fl_other_exempt",
        label: "Other Purpose Type",
        type: "checkbox",
        exclusiveGroup: "purposeOfWell",
        validation: ValidationSchemas.boolean,
        GridItem: { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
        optionLabels: {
          trueLabel: "Other Purpose Type",
          falseLabel: "Other Purpose Type",
          nullLabel: "Other Purpose Type",
        },
        infoTooltip:
          "Requires Drilling Permit. Complete this Well Notification Form and then contact the District Office for a Drilling Permit Application.",
      },
      {
        name: "other_desc",
        label: "Other Purpose Description",
        type: "text",
        validation: ValidationSchemas.string,
        showIf: {
          fn: (values) => values.fl_other_exempt,
          deps: ["fl_other_exempt"],
          resetValue: false,
          required: true,
        },
        refine: (data) => {
          if (data.fl_other_exempt && !data.other_desc) {
            return "Required if Other Purpose Type is selected";
          }
          return undefined;
        },
      },
    ],
  },

  /* ──────────────────  C. WELL LOCATION  ────────────────── */
  {
    title: "Well Location",
    step: "Well Location",
    fields: [
      {
        name: "copy_location_address",
        type: "custom",
        render: () => (
          <CopyFieldsButton
            label="Same as Owner Address"
            fieldMap={{
              address_line_1_owner: "address_line_1_location",
              address_city_owner: "address_city_location",
              address_state_owner: "address_state_location",
              address_zip_owner: "address_zip_location",
            }}
          />
        ),
      },
      {
        name: "address_line_1_location",
        label: "Physical Address",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_city_location",
        label: "City",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_state_location",
        label: "State",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "address_zip_location",
        label: "Zip",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      { name: "location_map", type: "map", label: "Find Lat/Lon/Elev" },
      {
        name: "latitude",
        label: "Latitude",
        type: "number",
        validation: ValidationSchemas.coordinate.lat,
        infoTooltip:
          "i.e. 30.1234567 (use decimal degrees, not degrees/minutes/seconds)",
      },
      {
        name: "longitude",
        label: "Longitude",
        type: "number",
        validation: ValidationSchemas.coordinate.lon,
        infoTooltip:
          "i.e. -97.1234567 (use decimal degrees, not degrees/minutes/seconds)",
      },
    ],
  },

  /* ───────────────────  D. WELL DETAIL  ─────────────────── */
  {
    title: "Well Detail",
    subtitle: "Provide any details you might have about the well.",
    step: "Well Detail",
    fields: [
      {
        name: "dt_drilled",
        label: "Date Drilled",
        type: "date",
        validation: ValidationSchemas.date,
      },
      {
        name: "id_contact_driller",
        label: "Driller",
        type: "selectSingle",
        lookupTable: lookupConfig.drillersList,
        validation: ValidationSchemas.positiveInt.nullable().optional(),
        defaultValue: null,
      },
      {
        name: "depth_well",
        label: "Well Depth (feet)",
        type: "text",
        validation: ValidationSchemas.string,
      },
    ],
  },

  /* ───────────────────  E. WELL RECORDS  ─────────────────── */
  {
    title: "Well Records",
    step: "Well Records",
    fields: [
      {
        name: "records_note",
        type: "subHeader",
        label: "Well records may be emailed to:",
        content: (
          <>
            Please email any hard-copies of well records (i.e. drillers log,
            State Well Report) to{" "}
            <a href="mailto:staff3@haysgroundwater.com">
              staff3@haysgroundwater.com
            </a>{" "}
            or mail to P.O. Box 1648, Dripping Springs, TX 78620.
          </>
        ),
      },
    ],
  },

  /* ───────────────────  F. PREPARED BY  ─────────────────── */
  {
    title: "Prepared By",
    subtitle:
      "By signing this form, I declare that I have knowledge of the information provided in this form and that it is true and correct, to the best of my knowledge and belief. Furthermore, I am familiar with all pertinent requirements contained in the Hays Trinity Groundwater Conservation District Rules including the District's well construction standards. I understand that within 60 days after the completion of the well, the driller must submit the State of Texas Well Report (Well Log) to the District.",
    step: "Prepared By",
    fields: [
      {
        name: "agrees_to_conditions",
        label:
          "I agree that my typed signature is binding and indicates my acceptance of the above statement.",
        type: "checkbox",
        validation: ValidationSchemas.requiredTrueBoolean,
      },
      {
        name: "contact_info",
        type: "subHeader",
        label: "Additional Contact Information (if different from Well Owner)",
      },
      {
        name: "copy_owner_info",
        type: "custom",
        render: () => (
          <CopyFieldsButton
            label="Same as Well Owner Information"
            fieldMap={{
              name_first_owner: "name_first_preparer",
              name_last_owner: "name_last_preparer",
            }}
          />
        ),
      },
      {
        name: "name_first_preparer",
        label: "First Name",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
      {
        name: "name_last_preparer",
        label: "Last Name",
        type: "text",
        validation: ValidationSchemas.requiredString,
      },
    ],
  },

  /* ───────────────────  G. COMMENTS  ─────────────────── */
  {
    title: "Comments Regarding the Well",
    step: "Comments",
    fields: [
      {
        name: "comment",
        label: "Comments",
        type: "text",
        validation: ValidationSchemas.string,
      },
      {
        name: "certification",
        type: "subHeader",
        label:
          "By pressing the submit button below, you certify the following:",
        content: (
          <>
            I herby register my well with Hays Trinity Groundwater Conservation
            District for the purposes indicated on this form. I certify that I
            am the property owner/grantor or lessee/grantee or an Authorized
            Agent, and that the information provided in this form is true and
            correct to the best of my knowledge. I will comply with HTGCD
            District Rules.
          </>
        ),
      },
    ],
  },
];

export default existingWellRegistrationFormConfig;
